import React from 'react';
import { motion } from 'framer-motion';

const AreasAtuacao = () => {
  const areas = [
    { 
      title: "Ginecologia Preventiva", 
      description: "A prevenção é a base para uma vida mais saudável e tranquila. Durante a consulta preventiva, avaliamos seu histórico, realizamos exames de rotina e o rastreamento de doenças ginecológicas, além de orientar sobre cuidados íntimos e hábitos que promovem seu bem-estar em todas as fases da vida.", 
      icon: "🛡️" 
    },
    { 
      title: "Saúde Sexual e Contracepção", 
      description: "A escolha do método contraceptivo deve levar em conta seu histórico, rotina e objetivos. Na consulta, avaliamos o que faz mais sentido para o seu caso, com foco em segurança, eficácia e adaptação ao seu corpo.", 
      icon: "💑" 
    },
    { 
      title: "Menopausa e Climatério", 
      description: "Durante a menopausa e climatério, é comum surgirem sintomas como ondas de calor, alterações no sono, queda da libido e mudanças de humor. Com acompanhamento adequado é possível aliviar os sintomas e devolver a qualidade de vida da mulher nessa fase.", 
      icon: "🌺" 
    },
    { 
      title: "SOP - Síndrome dos Ovários Policísticos", 
      description: "A Síndrome dos Ovários Policísticos é uma condição comum que afeta o ciclo menstrual e a fertilidade. Oferecemos diagnóstico preciso e tratamento personalizado para controlar sintomas e melhorar a qualidade de vida.", 
      icon: "🔄" 
    }
  ];

  const handleAgendar = () => {
    window.open("https://wa.me/5563991352552?text=Olá%2C%20gostaria%20de%20agendar%20uma%20consulta.", "_blank");
  };

  return (
    <section id="areas" className="py-20 px-4 bg-secondary/20">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-textDark mb-4">
            Áreas de Atuação
          </h2>
          <p className="text-textLight max-w-2xl mx-auto">
            Especialidades focadas na sua saúde, bem-estar e qualidade de vida
          </p>
          <div className="w-20 h-1 bg-primary mx-auto mt-4 rounded-full"></div>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {areas.map((area, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
              className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-2"
            >
              <h3 className="text-xl font-serif font-semibold text-primary mb-3">
                {area.title}
              </h3>
              <p className="text-textLight leading-relaxed text-sm">
                {area.description}
              </p>
            </motion.div>
          ))}
        </div>

        <div className="text-center mt-12">
          <button
            onClick={handleAgendar}
            className="bg-primary text-white px-8 py-3 rounded-full font-semibold hover:bg-primaryDark transition-all duration-300 hover:scale-105"
          >
            Agendar consulta
          </button>
        </div>
      </div>
    </section>
  );
};

export default AreasAtuacao;